import { PlannerSettingsStrings } from './PlannerSettingsStrings';
import { SchoolSettingsStrings } from './SchoolSettingsStrings';
import { SettingsSideBarStrings } from './SettingsSideBarStrings';

export const SettingsStrings = {
  planner: PlannerSettingsStrings,
  school: SchoolSettingsStrings,
  sidebar: SettingsSideBarStrings
};
